import { meta } from '../../meta';
import { getFormattedGoogleImages } from './getFormattedGoogleImages';

export const GOOGLE_FETCH_STATUS = {
  SUCCESS: 'success',
  FAILED: 'failed',
  ABORT: 'abort'
};

const DELAY = 300;
const MAX_RETRY = 5;

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export async function fetchGooglePhoto({
  source,
  signal,
  widgetToken,
  attempt = 0
}) {
  if (!source || !widgetToken || attempt === MAX_RETRY) {
    return { status: GOOGLE_FETCH_STATUS.FAILED, images: [] };
  }

  const url = new URL(meta.photosUrl);
  url.searchParams.set('source', source);

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: new Headers({
        'x-widget-token': widgetToken
      }),
      signal
    });
    const { code, payload } = await response.json();

    const isNotEmpty = response.ok && code === 200 && payload.length;
    if (isNotEmpty) {
      const images = getFormattedGoogleImages(payload);

      return { status: GOOGLE_FETCH_STATUS.SUCCESS, images };
    }

    const currentAttempt = attempt + 1;
    await delay(DELAY * currentAttempt);

    return fetchGooglePhoto({
      source,
      signal,
      widgetToken,
      attempt: currentAttempt
    });
  } catch (error) {
    if (error.name === 'AbortError') {
      console.warn('Request aborted');

      return { status: GOOGLE_FETCH_STATUS.ABORT, images: [] };
    }

    console.error(`Fetch failed: ${error.message}`);

    return { status: GOOGLE_FETCH_STATUS.FAILED, images: [] };
  }
}
